import { render } from "./BInputGroupPrepend.vue?vue&type=template&id=68bb01cc"
import script from "./BInputGroupPrepend.vue?vue&type=script&lang=js"
export * from "./BInputGroupPrepend.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__